export default __webpack_public_path__ + "static/steph-b4def02bb6eb6f8ccfb3bfd80e9fd0d9.svg";